// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"edcdd0c5","189":"cb830a25","453":"48bf6343","556":"08143a6a"}[chunkId] + ".chunk.js";
};